const PostType = Object.freeze({
  FB_COMMENT: 'FBComment',
  FB_LIKE: 'FBLike',
  FB_POST: 'FBPost',
  FM_REPLIES: 'FMReplies',
  FM_ORIGINAL: 'FMOriginal',
  TW_ORIGINAL: 'TWOriginal',
  TW_RETWEETS: 'TWRetweets',
  TW_REPLIES: 'TWReplies',
  TM_REBLOGS_W_COMMENTS: 'TMReblogsWComments',
  TM_REBLOGS_WO_COMMENTS: 'TMReblogsWOComments',
  TM_ORIGINAL: 'TMOriginal',
  TW_QUOTE: 'TWQuote',
  TW_INFORMAL_REPLIES: 'TWInformalReplies',
  ORIGINAL: 'Original',
  REPOST: 'Repost',
  REPLY: 'Reply',
  COMMENT: 'Comment',
  IT_MEDIA: 'ITMedia',
  IT_COMMENT: 'ITComment',
  YT_POST: 'YTPost',
  YT_COMMENT: 'YTComment',
  MO_ORIGINAL: 'MOOriginal',
  MO_REPOST: 'MORepost'
})
export default PostType
// RESERVE BELOW
